<template>
  <transition name="upload-toast-fade">
    <div class="upload-overlay" v-if="innerShow">
      <div class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p>{{ tipText }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LazyLoading',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    tipText: {
      type: String,
      default: '加载中，请稍候...'
    },
    minShowDuration: {
      type: Number,
      default: 520,
      validator: (val) => val >= 0
    },
    taskCompleted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerShow: false, 
      showTimer: null,
      minShowExpired: false 
    };
  },
  watch: {
    // 移除minShowDuration的immediate监听（避免初始化就触发）
    minShowDuration(val) {
      if (this.show && val > 0 && !this.showTimer) {
        this.resetTimer();
        this.showTimer = setTimeout(() => {
          this.minShowExpired = true; 
          this.checkIfCanHide();
        }, val);
      }
    },
    show(newVal) {
      if (newVal) {
        this.innerShow = true;
        this.minShowExpired = false;
        this.resetTimer();
        if (this.minShowDuration > 0) {
          this.showTimer = setTimeout(() => {
            this.minShowExpired = true;
            this.checkIfCanHide();
          }, this.minShowDuration);
        }
      } else {
        this.checkIfCanHide();
      }
    },
    taskCompleted: {
      immediate: true, // 立即监听，确保初始状态生效
      handler() {
        this.checkIfCanHide();
      }
    }
  },
  methods: {
    resetTimer() {
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = null;
      }
    },
    // 核心修改：必须同时满足 隐藏指令 + 最小时长过期 + 任务完成 才隐藏
    checkIfCanHide() {
      if (!this.show && this.minShowExpired && this.taskCompleted) {
        this.innerShow = false;
        this.resetTimer(); 
      }
    }
  },
  beforeDestroy() {
    this.resetTimer();
  }
};
</script>
<style lang="less" scoped>
.upload-overlay {
  position: fixed;
  bottom: 15px;
  right: 10px;
  width: 370px;
  height: 170px;
  background-color: #0091ea;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  pointer-events: none;
}

.loading-dots {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}

.loading-dots span {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ffffff;
  opacity: 0.7;
  animation: bounce 1.6s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.upload-overlay p {
  margin: 0;
  font-family: Arial, sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.upload-toast-fade-enter-active,
.upload-toast-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.upload-toast-fade-enter {
  opacity: 0;
  transform: translateY(20px);
}

.upload-toast-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>